import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

const dayjsExt = dayjs;
dayjsExt.extend(advancedFormat);

export { dayjsExt };
